'use client';

import React from 'react';
import { Textarea as NextUITextarea, TextAreaProps } from '@heroui/input';
import clsx from 'clsx';
import { mergeClasses } from '@/helpers/style';

interface CustomTextareaProps extends Omit<TextAreaProps, 'variant'> {
  variant?: 'outline';
}

const TextArea = ({ variant, ...props }: CustomTextareaProps) => {
  return (
    <NextUITextarea
      {...props}
      variant={variant === 'outline' ? 'bordered' : undefined}
      isInvalid={!!props.errorMessage || props.isInvalid}
      errorMessage={
        Array.isArray(props.errorMessage)
          ? props.errorMessage.join('\n')
          : props.errorMessage
      }
      classNames={{
        ...mergeClasses([
          {
            ...(variant === 'outline' && {
              inputWrapper: clsx(
                'border border-gray-light2 h-12 bg-transparent da data-[hover=true]:bg-transparent group-hover:opacity-80 shadow-none transition-opacity data-[focus=true]:!bg-transparent'
              ),
            }),
          },
          props.classNames as Record<string, string>,
        ]),
      }}
    />
  );
};

export default TextArea;
